import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  BreadcrumbModule,
  EmptyStateModule,
  LoaderModule,
  ModalModule,
  ScrollbarModule,
  StatusModule,
  TableModule,
  IconModule
} from '@michelin/theme';
import { WorkorderslistComponent } from './components/workorderslist/workorderslist.component';
import { WorkordersDetailsComponent } from './components/workorders-details/workorders-details.component';
import { SharedModule } from '../../shared/shared.module';
import { CustomerSelectModelComponent } from '../../shared/components/customer-select-model/customer-select-model.component';
import { WorkOrderLineListComponent } from './components/work-order-line-list/work-order-line-list.component';
import { WorkOrderLineDetailsComponent } from './components/work-order-line-details/work-order-line-details.component';
import { WorkOrderLineTabComponent } from './components/work-order-line-details/tabs/work-order-line-tab/work-order-line-tab.component';
import { LocationInformationTabComponent } from './components/work-order-line-details/tabs/location-information-tab/location-information-tab.component';
import { FinishedProductTabComponent } from './components/work-order-line-details/tabs/finished-product-tab/finished-product-tab.component';
import { AuditTrailTabComponent } from './components/work-order-line-details/tabs/audit-trail-tab/audit-trail-tab.component';
import { CasingHistoryTabComponent } from './components/work-order-line-details/tabs/casing-history-tab/casing-history-tab.component';
import { BulkWoModalComponent } from './shared/components/bulk-wo-modal/bulk-wo-modal.component';
import { WoLineModalComponent } from './shared/components/wo-line-modal/wo-line-modal.component';
import { MichelinDropdownAccessibilityDirective } from '../../shared/directives/michelin-dropdown-accessibility.directive';

@NgModule({
  declarations: [
    WorkorderslistComponent,
    WorkordersDetailsComponent,
    WorkOrderLineListComponent,
    WorkOrderLineDetailsComponent,
    LocationInformationTabComponent,
    FinishedProductTabComponent,
    CasingHistoryTabComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTableModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatTabsModule,
    MatExpansionModule,
    MatDividerModule,
    MatCardModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    DragDropModule,
    WorkOrderLineTabComponent,
    AuditTrailTabComponent,
    BreadcrumbModule,
    TableModule,
    StatusModule,
    EmptyStateModule,
    LoaderModule,
    IconModule,
    SharedModule,
    ScrollbarModule,
    CustomerSelectModelComponent,
    ModalModule,
    BulkWoModalComponent,
    WoLineModalComponent,
    MichelinDropdownAccessibilityDirective
  ],
  exports: [WorkorderslistComponent, WorkordersDetailsComponent, WorkOrderLineListComponent, WorkOrderLineDetailsComponent]
})
export class WorkorderModule {}
